import { SHOW_HEADER_LOGO, HIDE_HEADER_LOGO } from "./types";

export const showHeaderLogo = () => ({
  type: SHOW_HEADER_LOGO,
  payload: {}
});

export const hideHeaderLogo = () => ({
  type: HIDE_HEADER_LOGO,
  payload: {}
});



// WEBPACK FOOTER //
// ./src/services/ui/logo/actions.js